import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import SchedulePage from "@/pages/SchedulePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminBookings from "@/pages/AdminBookings";
import AdminBlockDates from "@/pages/AdminBlockDates";
import AdminFinance from "@/pages/AdminFinance";
import AdminInbox from "@/pages/AdminInbox";
import AdminPhotos from "@/pages/AdminPhotos";
import AdminVideos from "@/pages/AdminVideos";
import AdminAmenities from "@/pages/AdminAmenities";
import AdminServices from "@/pages/AdminServices";
import AdminRates from "@/pages/AdminRates";
import AdminSettings from "@/pages/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#13151D",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#F8F9FA",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminBookings />} />
            <Route path="block" element={<AdminBlockDates />} />
            <Route path="finance" element={<AdminFinance />} />
            <Route path="inbox" element={<AdminInbox />} />
            <Route path="photos" element={<AdminPhotos />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="amenities" element={<AdminAmenities />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="rates" element={<AdminRates />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
